import { lightColorPalette, darkColorPalette } from '@pearsontechnology/aero-components';

const themes = {
  light: { ...darkColorPalette },
  dark: { ...darkColorPalette },
  'extra-light': { ...lightColorPalette },
};

export default themes;
